import React, { useState } from "react"
import { Button, Divider, Typography } from "@material-ui/core"
import toastError from "../../../../errors/toastError"

/**
 * @typedef {Object} ExternalAdReplyPreviewProps
 * @property {string} cTitulo
 * @property {string} [cImagemUrl]
 * @property {string} cSourceUrl
 * @property {string} [cBody]
 * @property {string} [className]
 */

/**
 * Pré-visualização do anúncio CTWA (Facebook/Instagram) no bubble da mensagem.
 *
 * @param {ExternalAdReplyPreviewProps} props
 * @returns {JSX.Element}
 */
const ExternalAdReplyPreview = ({ cTitulo, cImagemUrl, cSourceUrl, cBody, className }) => {
  const [lImagemErro, setLImagemErro] = useState(false)
  const lExibirImagem = Boolean(cImagemUrl) && !lImagemErro

  const anuncioVisualizar = async () => {
    try {
      window.open(cSourceUrl, "_blank", "noopener,noreferrer")
    } catch (oErro) {
      toastError(oErro)
    }
  }

  return (
    <div className={className}>
      <div>
        {lExibirImagem && (
          <div style={{ float: "left" }}>
            <img
              src={cImagemUrl}
              alt={cTitulo || "Anúncio"}
              onError={() => setLImagemErro(true)}
              style={{ width: "100px", pointerEvents: "none", userSelect: "none" }}
            />
          </div>
        )}
        <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "column" }}>
          <Typography
            variant="caption"
            style={{ opacity: 0.7, marginTop: "8px", marginLeft: "15px", marginRight: "15px" }}
          >
            Anúncio do Facebook/Instagram
          </Typography>
          {cTitulo && (
            <Typography
              style={{ marginLeft: "15px", marginRight: "15px" }}
              variant="subtitle1"
              color="primary"
              gutterBottom
            >
              {cTitulo}
            </Typography>
          )}
          {cBody && (
            <Typography style={{ marginLeft: "15px", marginRight: "15px" }} variant="body2" gutterBottom>
              {cBody}
            </Typography>
          )}
        </div>
        <div style={{ display: "block", content: "", clear: "both" }}></div>
        {cSourceUrl && (
          <div>
            <Divider />
            <Button fullWidth color="primary" onClick={anuncioVisualizar} disabled={!cSourceUrl}>
              Visualizar
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ExternalAdReplyPreview
